export default "__VITE_ASSET__D5AXE_H___"